import axios from "axios"
import {isRequestError, RequestError} from "../../Model/RequestError";
import {acceptHeader, jsonContentTypeHeader, executeWithErrorResponseHandling} from "../ApiUtilities";
import {joinUrl} from "../../Utilities/UriUtilities";
import {COUNTER_API_CALLS} from "../../Service/CounterMetricsProvider";
import { ShortcodeSummary } from "../../Model/Shortcode/ShortcodeSummary";

/**
 * Function is responsible for calling the shortcode API which will return ShortcodeInfo
 */
export const fetchShortcodeSummary = async (
    domain: string,
    shortcode: string
): Promise<ShortcodeSummary | RequestError> => {
    const endpoint = joinUrl(domain, `/shortcodes/${shortcode}`)
    const headers = {...acceptHeader(), ...jsonContentTypeHeader()}

    const response = await executeWithErrorResponseHandling<ShortcodeSummary>(() =>
        axios.get(endpoint, {headers: headers}))

    if (isRequestError(response)) {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/shortcodes/{shortcode}", "status": "error"}})
        return response
    } else {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/shortcodes/{shortcode}", "status": "success"}})
        return response.data
    }
}
